import { render, staticRenderFns } from "./NeuesProjektErfassenModal.vue?vue&type=template&id=06f63bcb&"
import script from "./NeuesProjektErfassenModal.vue?vue&type=script&lang=js&"
export * from "./NeuesProjektErfassenModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports